import { Row, RowProps } from '@components/Layout/Row';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createMemo } from '@packages/react';
import React from 'react';

interface InlineLoadingProps extends RowProps {
    fullHeight?: boolean;
    size?: number;
    progressProps?: { [key: string]: any };
}

export const InlineLoading = createMemo<InlineLoadingProps>(
    (props) => {
        const { fullHeight, size, progressProps = {}, component, ...rest } = props;

        const Component: any = component;

        if (fullHeight) {
            rest.style = {
                ...rest.style,
                height: '100%',
            };
        }

        return (
            <Component {...rest}>
                <CircularProgress size={size} color={'primary'} {...(progressProps || {})} />
            </Component>
        );
    },
    {
        displayName: 'InlineLoading',
        defaultProps: {
            padding: 20,
            size: 24,
            component: Row,
            align: 'center',
            justify: 'center',
        },
    },
);

export default InlineLoading;
